import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import { DOCUMENT_TYPE } from "../../Constants"
import HttpClient from "../../helpers/HttpClient"
import PricingTable, { PricingTableDto } from "../PricingTable"
import { CreateGroupPayload, PatchPayload } from "./types"

class Service {
    static httpClient: HttpClient<PricingTable, PricingTableDto> = new HttpClient<PricingTable, PricingTableDto>(PricingTable)

    static async get(tableId: string) {
        return this.httpClient.get(`/pricing-tables/${tableId}/simplified`)
    }

    static async getTable(tableId: string) {
        return AppContext.getApiClient().get(`/pricing-tables/${tableId}`)
    }

    static async deleteRows(tableId: string, payload: string[]) {
        return AppContext.getApiClient().delete(`/pricing-tables/${tableId}/rows`, {rowIds: payload})
    }

    //endpoints to patch table should be created instead of using invoice / quote / order endpoints
    static async patch(documentType: DOCUMENT_TYPE, documentId: string, payload: PatchPayload) {
        return AppContext.getApiClient().patch(`/${documentType}/${documentId}`, payload)
    }

    static async createGroup(tableId: string, payload: CreateGroupPayload) {
        return AppContext.getApiClient().post(`/pricing-tables/${tableId}/groups`, payload)
    }

    static async createMultiProductFromReference(tableId: string, payload: CreateGroupPayload) {
        return AppContext.getApiClient().post(`/pricing-tables/${tableId}/multi-products-from-reference`, {
            rows: payload
        })
    }
}

export default Service


// WEBPACK FOOTER //
// ./src/state/pricing/services/service.ts